import { PdsWidget } from './pds-widget';

let xlinkns = 'http://www.w3.org/1999/xlink';

export class PdsLoader extends PdsWidget {
    is = 'pds-loader';
    dataAnnounceText: string;
    dataCompleteLoading: string;
    properties = {
        dataSize: {
            type: String,
            value: 'medium'
        },
        dataAnnounceText: {
            type: String,
            value: ''
        },
        dataCompleteLoading: {
            type: String,
            value: ''
        }
    };

    /**
     * Calls the polymer lifecycle hook when the component is attached.
     * This ensures that a screen reader knows that a page is loading when
     * the component is attached or detached.
     */

    attached(): void {
        // if data-announce-text attribute is not empty
        // trigger screenreader to say something.
        if (this.dataAnnounceText.trim() !== '') {
            this.pds.accessibility.announceViaScreenReader(this.dataAnnounceText);
        }
    }

    /**
     * Calls the polymer lifecycle hook when
     * the component is detached.
     * This ensures that a screen reader knows that a page is done loading when
     * the component is detached.
     */

    detached(): void {
      super.detached();
      if (this.dataCompleteLoading.trim() !== '') {
          this.pds.accessibility.announceViaScreenReader(this.dataCompleteLoading);
      }
    }

    getLoaderClassName(size: string): string {
        switch (size) {
            case 'small':
                return 'pds-loader-sm';
            case 'large':
                return 'pds-loader-lg';
            case 'medium':
            default:
                return 'pds-loader';
        }
    }
}
